var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import styled from '@xstyled/styled-components';
import { isFunction } from 'lodash/fp';
import { IconButtonInCell } from './IconButtonInCell';
var Center = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  width: 100%;\n\n  svg {\n    color: blue2;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  width: 100%;\n\n  svg {\n    color: blue2;\n  }\n"])));
export var RowActionsCell = function (_a) {
    var canEdit = _a.canEdit, onClick = _a.onClick, linkTo = _a.linkTo;
    var handleOnClick = useCallback(function () {
        if (isFunction(onClick)) {
            onClick();
        }
    }, [onClick]);
    var actions = useMemo(function () {
        var actionOptions = [];
        if (canEdit) {
            actionOptions.push(_jsx(IconButtonInCell, { icon: "pen", onClick: handleOnClick, linkTo: linkTo }, "edit"));
        }
        else {
            actionOptions.push(_jsx(IconButtonInCell, { icon: "chevronRight", onClick: handleOnClick, linkTo: linkTo }, "read"));
        }
        return actionOptions;
    }, [canEdit, handleOnClick, linkTo]);
    return _jsx(Center, { onClick: handleOnClick, children: actions });
};
var templateObject_1;
